import { useState } from 'react';

import { QuestionIcon, InfoSVG } from './Icons';

interface InfoIconProps {
  infoText: string;
  id?: string;
  className?: string;
  icon?: 'question' | 'info';
  variant?: 'primary' | 'secondary';
}

/**
 * @description This component is an infoicon that shows a tooltip when hovered over
 * @param infoText The text to show in the tooltip
 * @param id The id of the infoicon
 * @param className Addititonal classes to add to the infoicon
 * @param icon The icon to show in the infoicon. question or info. Defaults to question
 * @param variant The color of the infoicon. primary/blue or secondary/grey. Defaults to primary
 * @returns The InfoIcon component
 */

const InfoIcon = ({ infoText, id, className, icon, variant }: InfoIconProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className={`relative flex justify-center items-start ${className}`}>
      {icon === 'question' ? (
        <div onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
          <QuestionIcon className={`w-6 h-6 text-${variant === 'secondary' ? 'slate-500' : '[#4E73DF]'}`} />
        </div>
      ) : (
        <div onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
          <InfoSVG className={`w-6 h-6 text-${variant === 'secondary' ? 'slate-500' : '[#4E73DF]'}`} />
        </div>
      )}
      {showTooltip && (
        // Tooltip
        <div className={`absolute left-10 -top-1 w-fit z-50 p-2 text-white rounded-md shadow-md ${variant === 'secondary' ? 'bg-slate-500' : 'bg-[#4E73DF]'}`}>
          <div className={`w-4 h-4 ${variant === 'secondary' ? 'bg-slate-500' : 'bg-[#4E73DF]'} absolute top-1/2 left-[-8px] transform -translate-y-1/2 rotate-45`}></div>
          <p className='mx-2 text-sm font-medium whitespace-nowrap'>{infoText}</p>
        </div>
      )}
    </div>
  );
};

export default InfoIcon;
